// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"pa_a bhc_i bhc_j bhc_q bhc_un bhc_wf bhc_en"};